import { StrictMode } from 'react';

import { Home } from './pages/Home';

export const App = () => (
  <StrictMode>
    <Home />
  </StrictMode>
);
